import { ComponentProps } from "react";
import { cn } from "cn";
import { InputDebounced } from "./input-debounced";

/**
 * InputGroupInputDebounced is {@link InputDebounced} styled as the control of
 * a shadcn `InputGroup`. It is the counterpart of `InputGroupInput` for fields
 * that save while the user types, e.g. a field carrying a button inside the
 * input.
 *
 * The classes mirror `InputGroupInput`: the group draws the border, focus ring
 * and error state, the control inside it draws none of them.
 */
export function InputGroupInputDebounced({
  className,
  ...props
}: ComponentProps<typeof InputDebounced>) {
  return (
    <InputDebounced
      data-slot="input-group-control"
      className={cn(
        "flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent",
        className,
      )}
      {...props}
    />
  );
}
